/**
 * Official T-REX Network wordmark.
 * Sourced from the brand CDN; the SVG ships hard-coded white (#fff),
 * which matches the dark marketing site directly.
 */
const LOGO_URL =
  "https://cdn.prod.website-files.com/675802edd7177d3fdf4cc942/67b735ffb1eaf84dec9211ec_T-REX%20Logo%20White.svg";

export function TRexWordmark({ className = "h-6 w-auto", alt = "T-REX Network" }) {
  return <img src={LOGO_URL} alt={alt} className={className} draggable={false} />;
}
